<template>
    <div v-loading.fullscreen.lock="loading">
        <route-model-search-bar-component
            add_auth="新增权限分类"
            @search="get_route_model_index"
            @addTeam="addTeam"
        ></route-model-search-bar-component>
        <common-table-component
            details_auth="权限分类详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_route_model"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_route_model_index"
        ></common-page-component>
        <route-model-edit-component
            edit_auth="修改权限分类"
            del_auth="删除权限分类"
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :route_model_details_data="froute_model_details_data"
            @exitRouteModelDialog="dialogExit"
            @search="get_route_model_index"
            @show_edit="show_edit"
            @details_row="details_route_model"
        ></route-model-edit-component>
    </div>
</template>

<script>
import { route_model_index_request,route_model_details_request } from '@/network/RouteModel.js'

import RouteModelSearchBarComponent from '@/components/RouteModel/RouteModelSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import RouteModelEditComponent from '@/components/RouteModel/RouteModelEditComponent'

export default {
    name: 'RouteModelView',
    data() {
        return {
            fid: 0,
            edit_type: 0,
            fdialogFormVisible: false,
            loading: true,
            ftotal: 0,
            cond: {
                name: '',
                page: 1,
                limit: 10,
            },
            ftable_data: [],
            fcol_arr: [
                {
                    prop: 'iconImg',
                    label: '图标',
                    width: '65px',
                    icon: true,
                },
                {
                    prop: 'name',
                    label: '分类名称',
                    minWidth: '150px'
                },
            ],
            froute_model_details_data: {},
        }
    },
    computed: {},
    methods: {
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        get_route_model_index(param = {}) {
            this.loading = true
            this.cond.name = param.name ?? this.cond.name
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            route_model_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data.map((v) => {
                            v.iconImg = v.icon
                            return v
                        })
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_route_model(id) {
            this.fid = id
            this.fdialogFormVisible = true
            route_model_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.froute_model_details_data = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        },
    },
    filters: {},
    props: {},
    created() {
        this.get_route_model_index()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        RouteModelSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        RouteModelEditComponent,
    },
    watch: {},
}
</script>

<style lang='less'></style>